module.exports = __webpack_public_path__ + "img/zh_hk3.b8c75e82.png";